import type { PoiInfo } from '../interfaces';
import { MAP_API_PATH } from '../poiConfig';

export const AvinorPopup = ({ name, urls }: PoiInfo) => (
    <div className="poiPopupContent avinor">
        <div className="avinortable">
            <div>
                <span>
                    <a
                        target="_blank"
                        className="click-log logo"
                        href="//avinor.no"
                        data-logtype="10"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="Avinor" src={`${MAP_API_PATH}/images/avinor/Avinor-header.gif`} />
                    </a>
                </span>
            </div>
            <div>
                <span>
                    <a
                        target="_blank"
                        href={urls.flyplass}
                        className="click-log airport"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        data-logtype="2"
                        rel="noreferrer">
                        <img alt={name} title={name} src={`${MAP_API_PATH}/images/avinor/flyplass/${urls.objectId}.gif`} />
                    </a>
                </span>
            </div>
            <div>
                <span>
                    <a
                        target="_blank"
                        title={name}
                        href={urls.avganger}
                        className="click-log departure"
                        data-logtype="4"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="avgang" src={`${MAP_API_PATH}/images/avinor/Avinor-avgang.gif`} />
                    </a>
                </span>
                <span>
                    <a
                        target="_blank"
                        title={name}
                        href={urls.ankomst}
                        className="click-log departure"
                        data-logtype="5"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="ankomst" src={`${MAP_API_PATH}/images/avinor/Avinor-ankomst.gif`} />
                    </a>
                </span>
            </div>

            <div>
                <span>
                    <a
                        target="_blank"
                        title={name}
                        href={urls.direkteruter}
                        className="click-log direct"
                        data-logtype="14"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="direkte" src={`${MAP_API_PATH}/images/avinor/Avinor-direkte.gif`} />
                    </a>
                </span>
                <span>
                    <a
                        target="_blank"
                        href={urls.parkering}
                        title={name}
                        className="click-log parking"
                        data-logtype="13"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="parkering" src={`${MAP_API_PATH}/images/avinor/Avinor-parkering.gif`} />
                    </a>
                </span>
                <span>
                    <a
                        target="_blank"
                        href={urls.assistanse}
                        title={name}
                        className="click-log assistance"
                        data-logtype="12"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="assistanse" src={`${MAP_API_PATH}/images/avinor/Avinor-assistanse.gif`} />
                    </a>
                </span>
                <span>
                    <a
                        target="_blank"
                        href={urls.wifi}
                        title={name}
                        className="click-log wifi"
                        data-logtype="11"
                        data-typeid="42501"
                        data-objectid={urls.objectId}
                        rel="noreferrer">
                        <img alt="wifi" src={`${MAP_API_PATH}/images/avinor/Avinor-gratiswifi.gif`} />
                    </a>
                </span>
            </div>
        </div>
    </div>
);
